import {useIntl} from 'react-intl';

import {Button, view} from '@sail/ui';

import type {Conversation} from '@stripe-internal/conversations-client';

import {
  ConversationDisclaimerContent,
  DisclaimerText,
} from '../../../StripeAssistant/components/Footer/StripeAssistantDisclaimer';
import {disclaimerMessages} from '../../../core/messages';
import {useConversationEnded} from '../../../StripeAssistant/support/hooks/useConversationEnded';
import {
  useThreadsController,
  useThreadsConversationViewModelIsEnded,
  useThreadsDashboardUrl,
  useThreadsWithHistory,
} from '../../app/hooks';

type Props = {
  conversation?: Conversation | null;
};

function ThreadsActiveConversationFooter({
  conversation,
}: {
  conversation: Conversation;
}) {
  const intl = useIntl();
  const controller = useThreadsController();
  const dashboardUrl = useThreadsDashboardUrl();

  const isViewModelEnded = useThreadsConversationViewModelIsEnded();
  const isLiveConvoEnded = useConversationEnded(conversation);
  const isEnded = isViewModelEnded || isLiveConvoEnded;

  if (isEnded) {
    return (
      <view.div css={{stack: 'x', gap: 'small', padding: 'medium'}}>
        <Button
          type="secondary"
          css={{width: 'fill'}}
          href={`${dashboardUrl}/support`}
          target="_blank"
        >
          {intl.formatMessage(disclaimerMessages.viewSupportCases)}
        </Button>

        <Button
          type="primary"
          css={{width: 'fill'}}
          data-testid="threads-new-chat"
          onPress={() => controller.ui.startNewConversation()}
        >
          {intl.formatMessage(disclaimerMessages.newChat)}
        </Button>
      </view.div>
    );
  }

  return <ConversationDisclaimerContent conversation={conversation} />;
}

export function ThreadsConversationScreenFooter({conversation}: Props) {
  const intl = useIntl();
  const withHistory = useThreadsWithHistory();

  if (!conversation) {
    return (
      <DisclaimerText
        text={intl.formatMessage(disclaimerMessages.disclaimer)}
      />
    );
  }

  if (!withHistory) {
    return <ConversationDisclaimerContent conversation={conversation} />;
  }

  return <ThreadsActiveConversationFooter conversation={conversation} />;
}
